export const getYourGuideWidgets: Record<string, string> = {
  phuket: '135719,626577,509799',
};
